import { rejectImageFile } from '../work/image-upload-limits';

export { rejectImageFile };

/** Text inserted while an upload is in flight; unique per upload so it can be found and replaced. */
export function uploadPlaceholder(id: string, name: string): string {
  return `![Uploading ${imageAlt(name)}… ${id}]()`;
}

const URL_ESCAPES: Record<string, string> = { '(': '%28', ')': '%29', ' ': '%20' };

/** `![alt](url)` with the characters that would end the alt text or the URL escaped. */
export function imageMarkdown(name: string, url: string): string {
  const safeUrl = url.replace(/[() \t\r\n]/g, (char) => URL_ESCAPES[char] ?? encodeURIComponent(char));
  return `![${imageAlt(name)}](${safeUrl})`;
}

function imageAlt(name: string): string {
  return name.replace(/\.[a-z0-9]+$/i, '').replace(/[[\]]/g, '\\$&');
}
